<!-- <div class="loader-wrapper position-fixed h-100 w-100 d-flex align-items-center justify-content-center" *ngIf="headFootVisible && loader">
  <div class="loader"></div>  
</div> -->
<div class="dashboard-parent">
  <div class="dashboard-wrapper">
    <ng-container *ngIf="headFootVisible; else shownLogo">
      <div
        class="inner-page-header inner-page-header--dashboard d-flex flex-column align-items-center"
      >
        <h1>{{ "pages.dashboard" | translate }}</h1>
      </div>
    </ng-container>
    <ng-template #shownLogo>
      <div
        class="inner-page-header inner-page-header--dashboard inner-page-header--no-header d-flex flex-row align-items-center justify-content-center"
      >
        <img
          title="UMANG"
          alt="UMANG-logo"
          src="assets/images/umang-logo-emb.svg"
          class="cursor-pointer"
          alt="UMANG"
          width="200px"
          loading="lazy"
          fetchpriority="high"
          (click)="redirectToUmang()"
        />
      </div>
    </ng-template>

    <!-- <p class="page-sub-title">{{'dashboard.page-title' | translate}}</p> -->
  </div>
  <div class="container">
    <!-- <div class="iframe-wrapper">
        <iframe
          class="iframeWeb"
          [scrolling]="scroll"
          [src]="dashboardSafeUrl"
          frameborder="0"
        ></iframe>
      </div> -->
    <div class="px-1">
      <p class="text-right capture_content mt-3">
        {{ "dashboardLang.dataCapturedTill" | translate }}
        {{ priorDate | date : "MMM yyyy" }}
      </p>
    </div>
    <div class="row row--dashboard">
      <div class="col-6 col-sm-6 col-md-3">
        <div
          class="dashboard-card position-relative"
          style="height: 180px; background-color: #c2e6fe"
        >
          <div class="dashboard-card__header d-flex align-items-center">
            <app-total-users-svg></app-total-users-svg>
            <p class="mb-0">{{ "dashboard.totalUser" | translate }}</p>
          </div>
          <div class="dashboard-card__body">
            <h4
              class="position-absolute mb-0"
              app-animating-count
              [count]="statData?.totaluser"
              [skips]="1000000"
              [enableINRformat]="true"
              [registrationConvertToCrore]="true"
              [interval]="1"
            ></h4>
            <span class="graph-img w-100">
              <app-total-users-graph-svg></app-total-users-graph-svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3">
        <div
          class="dashboard-card position-relative cursor-pointer"
          style="height: 180px; background: #fff4de"
          (click)="redirectTORoute('/services')"
        >
          <div class="dashboard-card__header d-flex align-items-center">
            <img
              src="assets/images/availed-services.svg"
              alt=""
              width="24"
              height="24"
            />
            <p class="mb-0">{{ "dashboard.totalService" | translate }}</p>
          </div>
          <div class="dashboard-card__body">
            <h4
              class="position-absolute mb-0"
              app-animating-count
              [count]="statData?.totalservice"
              [skips]="1500"
              [interval]="1"
            ></h4>

            <span class="graph-img w-100">
              <app-availed-services-graph-svg></app-availed-services-graph-svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3">
        <div
          class="dashboard-card position-relative"
          style="height: 180px; background: #dcfce7"
        >
          <div class="dashboard-card__header d-flex align-items-center">
            <app-issued-documents-svg></app-issued-documents-svg>
            <p class="mb-0">{{ "stats.documents" | translate }}</p>
          </div>
          <div class="dashboard-card__body">
            <h4
              class="position-absolute mb-0"
              app-animating-count
              [count]="docScheme?.documents + docScheme?.documentsCenter"
              [skips]="100"
              [interval]="1"
            ></h4>
            <span class="graph-img w-100">
              <app-issues-documents-graph-svg></app-issues-documents-graph-svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-3">
        <div
          class="dashboard-card position-relative cursor-pointer"
          style="height: 180px; background: #f4e8ff"
          (click)="redirectTORoute('/scheme/dashboard')"
        >
          <div class="dashboard-card__header d-flex align-items-center">
            <app-availed-scheme-svg></app-availed-scheme-svg>
            <p class="mb-0">{{ "dashboard.totalSchemes" | translate }}</p>
          </div>
          <!-- {{docScheme?.schemes}}
            {{docScheme?.schemesCenter}}
            {{docScheme?.documents}}
            {{docScheme?.documentsCenter}} -->
          <div class="dashboard-card__body">
            <h4
              class="position-absolute mb-0"
              app-animating-count
              [count]="statData?.totalschemes"
              [skips]="500"
              [interval]="1"
            ></h4>
            <span class="graph-img w-100">
              <app-availed-scheme-graph-svg></app-availed-scheme-graph-svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6 mobile-padding">
        <div class="dashboard-card">
          <div
            class="dashboard-card__header d-flex align-items-center justify-content-between"
          >
            <h3 class="mb-0">{{ "stats.registrations" | translate }}</h3>
            <mat-icon
              class="cursor-pointer"
              (click)="
                showChartFullScreen(userStats, 'Registrations', 'canvas6')
              "
              >fullscreen</mat-icon
            >
          </div>
          <div class="dashboard-card__body position-relative">
            <app-year-wise
              *ngIf="isPlatformBrowser"
              [yearData]="userStats"
              canvasId="canvas1"
              [config]="lineConfig"
            ></app-year-wise>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="dashboard-card">
          <div
            class="dashboard-card__header d-flex align-items-center justify-content-between"
          >
            <h3 class="mb-0">{{ "stats.transactions" | translate }}</h3>
            <mat-icon
              class="cursor-pointer"
              (click)="
                showChartFullScreen(transStats, 'Transactions', 'canvas4')
              "
              >fullscreen</mat-icon
            >
          </div>
          <div class="dashboard-card__body position-relative">
            <app-year-wise
              *ngIf="isPlatformBrowser"
              [yearData]="transStats"
              canvasId="canvas2"
              [config]="lineConfig"
            ></app-year-wise>
          </div>
        </div>
      </div>
      <div class="col-md-6" id="services">
        <div class="dashboard-card">
          <div
            class="dashboard-card__header d-flex align-items-center justify-content-between"
          >
            <h3 class="mb-0">{{ "dept-details.services" | translate }}</h3>
            <mat-icon
              class="cursor-pointer"
              (click)="showChartFullScreen(serviceStats, 'Services', 'canvas5')"
              >fullscreen</mat-icon
            >
          </div>
          <div class="dashboard-card__body position-relative">
            <app-year-wise
              *ngIf="isPlatformBrowser"
              [yearData]="serviceStats"
              canvasId="canvas3"
              [config]="lineConfig"
            ></app-year-wise>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="dashboard-card">
          <div class="dashboard-card__header d-flex align-items-center">
            <h3>{{ "dashboard.serviceIntegrated" | translate }}</h3>
          </div>
          <div class="dashboard-card__body position-relative">
            <app-department-service
              *ngIf="isPlatformBrowser"
              [data]="serviceIntegrated"
            ></app-department-service>
          </div>
        </div>
      </div>
      <div class="col-md-12" id="stateWise">
        <div class="dashboard-card">
          <div
            class="dashboard-card__header d-flex align-items-center justify-content-between"
          >
            <h3>{{ "dashboard.stateWise" | translate }}</h3>
            <div class="d-flex filter">
              <button
                class="d-flex align-items-center csv"
                (click)="download()"
              >
                {{ "dashboardLang.exportCSV" | translate }}
                <mat-icon>cloud_download</mat-icon>
              </button>
              <mat-form-field class="dashboard-filter">
                <mat-select
                  panelClass="my-panel-left"
                  [(value)]="currentState"
                  (selectionChange)="onstateChanges($event)"
                >
                  <mat-option
                    *ngFor="let state of states"
                    [value]="state.stateId"
                    class="dashboard-options"
                  >
                    {{ state.stateName | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div
            class="dashboard-card__body position-relative"
            *ngIf="stateWiseStats"
          >
            <app-state-wise-distribution
              *ngIf="isPlatformBrowser"
              #stateWise
              [data]="stateWiseStats"
              [currentState]="currentState"
              (updateState)="onstateChanges($event)"
              (stateData)="SchemeDoc($event)"
            ></app-state-wise-distribution>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <div class="dashboard-card">
          <div
            class="dashboard-card__header d-flex align-items-center justify-content-between"
          >
            <h3>{{ "dashboard.topDept" | translate }}</h3>
          </div>
          <div class="dashboard-card__body position-relative">
            <div class="row">
              <div class="col-md-6">
                <app-top-department-service
                  *ngIf="isPlatformBrowser"
                  [isDepartment]="true"
                  [deptResp]="deptList"
                ></app-top-department-service>
              </div>
              <div class="col-md-6">
                <app-top-department-service
                  *ngIf="isPlatformBrowser"
                  [isDepartment]="false"
                  [serviceResp]="serviceList"
                ></app-top-department-service>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
